<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div id="hoeheDesGrundOderStammkapitals">

    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.HOEHE_GRUND_STAMMKAPITAL_TITEL' | translate }}</h2>

    <div *ngIf="!isKapGAus">
      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="hoeheGrundStammkapital">
          {{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.HOEHE' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control text-right pr-3x" datevMessagePath="hoeheGrundStammkapital{{objectId}}" formControlName="hoeheGrundStammkapital" id="hoeheGrundStammkapital"
                 type="text" numeric transformNumber utilsCheckValidity
                 utilsControlState utilsMarkRequired
                 utilsValidationMessage/>
          <em class="icon-euro"></em>
        </div>
      </div>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="daraufEingezahlt">
          {{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.EINGEZAHLT' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control text-right pr-3x" datevMessagePath="daraufEingezahlt{{objectId}}" formControlName="daraufEingezahlt" id="daraufEingezahlt"
                 type="text" numeric transformNumber utilsCheckValidity
                 utilsControlState utilsMarkRequired
                 utilsValidationMessage/>
          <em class="icon-euro"></em>
        </div>
      </div>
    </div>

    <div *ngIf="isKapGAus">
      <div class="form-row d-none d-sm-block">
        <label
          class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.HOEHE' | translate }}</label>
        <label class="col-sm-2"></label>
        <label
          class="col-form-label col-sm-5"
          for="hoeheGrundStammkapitalWaehrungsangabeEnum">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.WAEHRUNGSANGABE' | translate }}</label>
      </div>
      <div class="form-row justify-content-between">
        <label class="d-sm-none col-form-label" for="hoeheGrundStammkapitalKapG">
          {{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.HOEHE' | translate }}
        </label>
        <div class="col-sm-5">
          <input [checkAdditionalControls]="['hoeheGrundStammkapitalWaehrungsangabeEnum','hoeheGrundStammkapitalWaehrungsangabe']" class="form-control text-right pr-3x" datevMessagePath="hoeheGrundStammkapital{{objectId}}"
                 formControlName="hoeheGrundStammkapital" id="hoeheGrundStammkapitalKapG"
                 type="text" numeric transformNumber utilsCheckValidity utilsControlState
                 utilsMarkRequired

                 utilsValidationMessage/>
        </div>
        <label class="d-sm-none col-form-label" for="hoeheGrundStammkapitalWaehrungsangabe">
          {{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.WAEHRUNGSANGABE' | translate }}
        </label>
        <div class="col-sm-5">
          <select class="form-control" datevMessagePath="hoeheGrundStammkapitalWaehrungsangabeEnum{{objectId}}"
                  formControlName="hoeheGrundStammkapitalWaehrungsangabeEnum" id="hoeheGrundStammkapitalWaehrungsangabeEnum"
                  utilsCheckValidity utilsControlState utilsMarkRequired
                  utilsValidationMessage>
            <option *ngFor="let currency of mainCurrencies"
                    [ngValue]="currency.value">{{ 'COMMON_UI.CURRENCY.' + currency.value | translate }}</option>
            <option [ngValue]="" disabled>---</option>
            <option *ngFor="let currency of otherCurrencies"
                    [ngValue]="currency.value">{{ currency.value | translate }}</option>
          </select>
          <input *ngIf="data.hoeheGrundStammkapitalWaehrungsangabeEnum === '999'" class="form-control pr-3x"
                 datevMessagePath="hoeheGrundStammkapitalWaehrungsangabe{{objectId}}" formControlName="hoeheGrundStammkapitalWaehrungsangabe"
                 id="hoeheGrundStammkapitalWaehrungsangabe"
                 type="text"
                 utilsCheckValidity utilsControlState utilsMarkRequired
                 utilsValidationMessage/>
        </div>
      </div>

      <div class="form-row d-none d-sm-block">
        <label
          class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.EINGEZAHLT' | translate }}</label>
        <label class="col-sm-2"></label>
        <label
          class="col-form-label col-sm-5"
          for="daraufEingezahltWaehrungsangabeEnum">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.WAEHRUNGSANGABE' | translate }}</label>
      </div>
      <div class="form-row justify-content-between">
        <label class="d-sm-none col-form-label" for="daraufEingezahltKapG">
          {{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.EINGEZAHLT' | translate }}
        </label>
        <div class="col-sm-5">
          <input [checkAdditionalControls]="['daraufEingezahltWaehrungsangabeEnum','daraufEingezahltWaehrungsangabe']" class="form-control text-right pr-3x" datevMessagePath="daraufEingezahlt{{objectId}}"
                 formControlName="daraufEingezahlt" id="daraufEingezahltKapG"
                 type="text" numeric transformNumber utilsCheckValidity utilsControlState
                 utilsMarkRequired
                 utilsValidationMessage/>
        </div>
        <label class="d-sm-none col-form-label" for="daraufEingezahltWaehrungsangabe">
          {{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.WAEHRUNGSANGABE' | translate }}
        </label>
        <div class="col-sm-5">
          <select class="form-control" datevMessagePath="daraufEingezahltWaehrungsangabeEnum{{objectId}}"
                  formControlName="daraufEingezahltWaehrungsangabeEnum" id="daraufEingezahltWaehrungsangabeEnum"
                  utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage>
            <option *ngFor="let currency of mainCurrencies"
                    [ngValue]="currency.value">{{ 'COMMON_UI.CURRENCY.' + currency.value | translate }}</option>
            <option [ngValue]="" disabled>---</option>
            <option *ngFor="let currency of otherCurrencies"
                    [ngValue]="currency.value">{{ currency.value | translate }}</option>
          </select>
          <input *ngIf="data.daraufEingezahltWaehrungsangabeEnum === '999'" class="form-control pr-3x"
                 datevMessagePath="daraufEingezahltWaehrungsangabe{{objectId}}" formControlName="daraufEingezahltWaehrungsangabe"
                 id="daraufEingezahltWaehrungsangabe"
                 type="text"
                 utilsCheckValidity utilsControlState utilsMarkRequired
                 utilsValidationMessage/>
        </div>
      </div>
    </div>
  </div>
</form>
